<template>
  <section>
    <ValidationProvider rules="required" v-slot="{ errors }">
    <div class="header mb-3 mt-3 p-0 md:p-2 ml-8 md:ml-0">
      <h2 class="font-bold text-gray-700 text-xl">
        <i class="bx bxs-credit-card-front text-indigo-500 -m-8 mr-1"></i>
        MÉTODO DE PAGAMENTO
      </h2>
      <small class="text-gray-600">Escolha o seu método de pagamento abaixo</small>
    </div>
    <div class="mb-2" :data-check="false">
      <payment-card
        @click.native="doPaymentSelect(1)"
        :selected="paymentSelect  == 1 ? true : false"
        name="Cartão de Crédito"
        icon="bxs-credit-card"
      >
        <template v-slot:form v-if="paymentSelect  === 1">
          <div class="border-t md:px-6 md:py-8 p-3 flex flex-wrap bg-gray-200">
            <div class="w-full p-1">
              <ValidationProvider rules="required" v-slot="{ errors }">
              <label for class="text-sm font-bold">N° do Cartão:</label>
              <t-input
                v-model="cardBin"
                id="cardNumber"
                data-checkout="cardNumber"
                @change="getInstallments()"
                class="w-full"
                :variant="errors.length > 0 ? 'danger' : 'credit' "
                placeholder="Numero do cartão:"
                v-mask="['#### ###### #####', '#### #### #### ####']"
              />
               <span class="text-red-500 block pt-1" v-if="errors.length">
                  <i class="bx bx-error mr-1"></i>
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
            <div class="w-full md:w-2/4 p-1">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <label for class="text-sm font-bold">Nome no Cartão:</label>
              <t-input
                data-checkout="cardholderName"
                v-model="cardHolderName"
                class="w-full"
                :variant="errors.length > 0 ? 'danger' : 'credit' "
                placeholder="Nome no cartão:"
              />
              <span class="text-red-500 block pt-1" v-if="errors.length">
                <i class="bx bx-error mr-1"></i>
                {{ errors[0] }}
              </span>
            </ValidationProvider>
            </div>
            <div class="w-1/2 md:w-1/4 p-1">
              <label for class="text-sm font-bold">Validade:</label>
              <input type="hidden" placeholder="MM" id="cardExpirationMonth" data-checkout="cardExpirationMonth"
                onselectstart="return false" onpaste="return false"
                oncopy="return false" oncut="return false"
                ondrag="return false" ondrop="return false" autocomplete=off>
              <input type="hidden" placeholder="YY" id="cardExpirationYear" data-checkout="cardExpirationYear"
                onselectstart="return false" onpaste="return false"
                oncopy="return false" oncut="return false"
                ondrag="return false" ondrop="return false" autocomplete=off>
              <ValidationProvider rules="required" v-slot="{ errors }">
              <t-input
                v-model="cardDueDate"
                class="w-full"
               :variant="errors.length > 0 ? 'danger' : 'credit' "
                placeholder="Mês/Ano:"
                v-mask="['##/##']"
              />
              <span class="text-red-500 block pt-1" v-if="errors.length">
                <i class="bx bx-error mr-1"></i>
                {{ errors[0] }}
              </span>
              </ValidationProvider>
            </div>
             <div class="w-1/2 md:w-1/4 p-1">
             <ValidationProvider rules="required" v-slot="{ errors }">
              <label for class="text-sm font-bold">CVV:</label>
              <t-input
                data-checkout="securityCode"
                v-model="cardCvv"
                class="w-full"
                :variant="errors.length > 0 ? 'danger' : 'credit' "
                placeholder="CVV:"
                v-mask="['###', '####']"
              />
              <span class="text-red-500 block pt-1" v-if="errors.length">
                <i class="bx bx-error mr-1"></i>
                {{ errors[0] }}
              </span>
            </ValidationProvider>
            </div>
            <div class="w-full p-1">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <label for class="text-sm font-bold">Parcelas:</label>
                <t-select
                :variant="errors.length > 0 ? 'danger' : '' "
                placeholder="Selecione..." class="w-full" :options="options" v-model="cardPlots"></t-select>
                <span class="text-red-500 block pt-1" v-if="errors.length">
                  <i class="bx bx-error mr-1"></i>
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>
        </template>
      </payment-card>
    </div>
    <div class="mb-8">
      <payment-card
        name="Boleto"
        @click.native="doPaymentSelect(2)"
        :selected="paymentSelect  == 2 ? true : false "
        icon="bxs-barcode"
      >
        <template v-slot:form v-if="paymentSelect  === 2">
          <div class="border-t md:px-6 md:py-8 p-3 flex flex-wrap bg-gray-200">
            <div class="w-full">
              <p>
                Total a ser pago
                <strong>{{ $store.state.total_price | toCurrency}}</strong>
              </p>
            </div>
          </div>
        </template>
      </payment-card>
    </div>
      <span class="text-red-500 block pb-1 mb-2" v-if="errors.length">
        <i class="bx bx-error mr-1"></i>
        {{ errors[0] }}
      </span>
      <input type="hidden" name="paymentSelect" v-model="paymentSelect">
    </ValidationProvider>
  </section>
</template>

<script>
import PaymentCard from '@/components/PaymentCard'

export default {
  components: {
    PaymentCard
  },
  computed: {
    cardHolderName: {
      get () {
        return this.$store.state.cardHolderName
      },
      set (value) {
        this.$store.state.cardHolderName = value
      }
    },
    paymentSelect: {
      get () {
        return this.$store.state.paymentSelect
      },
      set (value) {
        this.$store.state.paymentSelect = value
      }
    },
    cardBin: {
      get () {
        return this.$store.state.cardBin
      },
      set (value) {
        this.$store.state.cardBin = value
      }
    },
    cardCvv: {
      get () {
        return this.$store.state.cardCvv
      },
      set (value) {
        this.$store.state.cardCvv = value
      }
    },
    cardDueDate: {
      get () {
        return this.$store.state.cardDueDate
      },
      set (value) {
        this.$store.state.cardDueDate = value
      }
    },
    cardPlots: {
      get () {
        return this.$store.state.cardPlots
      },
      set (value) {
        this.$store.state.cardPlots = value
      }
    },
    cardBirthDate: {
      get () {
        return this.$store.state.cardBirthDate
      },
      set (value) {
        this.$store.state.cardBirthDate = value
      }
    }
  },
  data () {
    return {
      options: null
    }
  },
  methods: {
    getInstallments () {
      if (this.cardBin.length >= 6) {
        window.payment.getInstallments({
          number: this.cardBin,
          total_price: this.$store.state.total_price
        }).then((response) => {
          this.options = response.installments
          console.log(response)
          this.$store.commit('CARDBRAND', response.payment_method_id)
          return true
        })
      }
      this.options = []
    },
    doPaymentSelect (value) {
      this.paymentSelect = value
    }
  }
}
</script>

<style>
</style>
